import React from "react";
import { Card } from "@mantine/core";
import { TbTrendingUp } from "react-icons/tb";
import { useGetTotalRevenue } from "../../../../hooks/queries/useTransactionQueries";
import FetchFeedback from "../../../ui/CustomFetchFeedback/CustomFetchFeedback";
import StatCard from "./statCard";
import StatCardSkeleton from "./StatCardSkeleton";
import { formatKES } from "../../../../utils/transactionutils";

export default function CollectionsStatCard() {
  const { data, isLoading, isError, refetch } = useGetTotalRevenue();

  if (isLoading) {
    return <StatCardSkeleton className="bg-white-50" />;
  }

  if (isError) {
    return (
      <Card className="bg-white-50 min-h-[100px] sm:min-h-[130px] flex items-center justify-center p-3 sm:p-6">
        <FetchFeedback
          message="Failed to load collections."
          onRetry={refetch}
          fullHeight={false}
          compact
        />
      </Card>
    );
  }

  return (
    <StatCard
      icon={<TbTrendingUp className="w-4 h-4 text-green-500" />}
      label="Total Collections"
      value={
        <span className="break-words">
          {formatKES(data?.totalRevenueAmount)}
        </span>
      }
      className="bg-white-50"
    />
  );
}
